import Styles from './Styles.module.scss';

const Activity = ({ message, ...props }) => {
  return <div className={Styles.content} dangerouslySetInnerHTML={{ __html: message?.content }} />;
};

export default Activity;
